import { Component, Inject, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { DefaultActionFactory, DefaultActionFactoryToken } from "@core/redux/redux.module";
import { Subject, Subscription } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import * as _ from "lodash";

@Component({
  selector: "code-modify-modal",
  templateUrl: "./code-modify-modal.component.html"
})
export class CodeModifyModalComponent implements OnDestroy {

  private _destroy$: Subject<boolean> = new Subject<boolean>();
  public modifyModalFormGroup: FormGroup;
  protected formSubscription: Subscription;
  private actionFactory: DefaultActionFactory;
  public isIE11 = false;

  constructor (
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<CodeModifyModalComponent>,
    @Inject(DefaultActionFactoryToken)
      defaultActionFactory: DefaultActionFactory
  ) {
    this.isIE11 = !!navigator.userAgent.match(/Trident\/7\./);
    this.actionFactory = defaultActionFactory;
    this.modifyModalFormGroup = this.formBuilder.group({
      originalSecureCode: [this.data],
      secureCode: [""],
      secureCode2: [""]
    });
    this.modifyModalFormGroup.get("secureCode").setValidators([
      Validators.required,
      Validators.minLength(4),
      this.prevCodeValidator(this.modifyModalFormGroup.get("originalSecureCode"))]);
    this.modifyModalFormGroup.get("secureCode2").setValidators([
      Validators.required,
      this.sameCodeValidator(this.modifyModalFormGroup.get("secureCode"))]);
    this.formSubscription = this.modifyModalFormGroup.valueChanges.pipe(
      debounceTime(200)).subscribe(data => {
        if ((this.modifyModalFormGroup.get("secureCode").value && this.modifyModalFormGroup.get("secureCode2").value) &&
          this.modifyModalFormGroup.get("secureCode").value.length === 4 &&
          this.modifyModalFormGroup.get("secureCode2").value.length === 4) {
          this.modifyModalFormGroup.get("secureCode").updateValueAndValidity();
          this.modifyModalFormGroup.get("secureCode2").markAsTouched();
          this.modifyModalFormGroup.get("secureCode2").updateValueAndValidity();
        }
    });
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }

  prevCodeValidator(originalSecureCodeControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if ((control.value && originalSecureCodeControl.value) && _.parseInt(control.value, 0) === _.parseInt(originalSecureCodeControl.value, 0)) {
        return { "sameAsPresent": true };
      }
      return null;
    };
  }

  sameCodeValidator(secureCodeCodeControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if ((control.value && secureCodeCodeControl.value) && control.value !== secureCodeCodeControl.value) {
        return { "notSameCodes": true };
      }
      return null;
    };
  }

  close() {
      this.dialogRef.close();
  }

  doModify() {
    this.modifyModalFormGroup.get("secureCode").updateValueAndValidity();
    this.modifyModalFormGroup.get("secureCode2").updateValueAndValidity();
    if (this.modifyModalFormGroup.valid) {
      this.actionFactory.modifyStaticPassword({
        staticPassword:  this.modifyModalFormGroup.get("secureCode").value
      }).pipe(
        takeUntil(this._destroy$)
      ).subscribe( resp => {
        this.dialogRef.close({ success: true, data: this.modifyModalFormGroup.getRawValue()});
      }, error => {
        this.dialogRef.close({ success: false, data: this.modifyModalFormGroup.getRawValue()});
      });
    }
  }
}
